var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreatethan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.28841 16.8988L8.15327 9.99964L1.28841 3.10052C0.669978 2.47546 0.669978 1.47027 1.28841 0.845206C1.58672 0.543568 1.99391 0.374158 2.41854 0.375012C2.84302 0.373857 3.25009 0.54333 3.54794 0.845206L11.5341 8.87162C11.8338 9.17064 12.0015 9.57669 12 9.99964C12.0014 10.4224 11.8337 10.8281 11.5341 11.1269L3.54794 19.1548C3.2499 19.4564 2.84296 19.6258 2.41854 19.625C1.99387 19.6253 1.58679 19.4557 1.28841 19.1541C0.669978 18.529 0.669978 17.5238 1.28841 16.8988Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreatethan);
export default __webpack_public_path__ + "static/media/Greatethan.72627ac608b01b3c788ae1692d986a58.svg";
export { ForwardRef as ReactComponent };